const VALIDATE_TTL_MS = 1_800_000;

type ValidateSnapshot = {
  payload: unknown;
  storedAt: number;
};

let snapshot: ValidateSnapshot | null = null;

const clonePayload = <T>(value: T): T => {
  if (typeof structuredClone === "function") {
    return structuredClone(value);
  }
  return JSON.parse(JSON.stringify(value)) as T;
};

export const getValidateSnapshot = <T = unknown>(): T | null => {
  if (!snapshot) {
    return null;
  }
  if (Date.now() - snapshot.storedAt >= VALIDATE_TTL_MS) {
    snapshot = null;
    return null;
  }
  return clonePayload(snapshot.payload) as T;
};

export const setValidateSnapshot = (payload: unknown): void => {
  if (!payload) {
    return;
  }
  snapshot = {
    payload: clonePayload(payload),
    storedAt: Date.now(),
  };
};

export const clearValidateSnapshot = (): void => {
  snapshot = null;
};

/** Keeps a later cached validate in step with a pin save. */
export const patchValidatePinnedTabs = (ids: string[]): void => {
  const customer = (snapshot?.payload as { data?: { data?: { customer?: Record<string, unknown> } } })
    ?.data?.data?.customer;
  if (!customer) return;
  customer.pinnedTabs = ids;
  customer.hasSavedPinnedTabs = true;
};
